<template>
  <main>
    <navigation v-if="isLoggedIn" />
    <router-view></router-view>
  </main>
  <Toaster position="top-right" :duration="5000" />
</template>

<script setup>
import 'vue-sonner/style.css'
import { computed } from 'vue'
import Navigation from "@/components/Navigation.vue";
import { Toaster } from '@/components/ui/sonner';
import router from "@/router/index.js";
import store from "@/store/index.js";

const isLoggedIn = computed(() => {
  const routename = router.currentRoute.value.path
  if (store.getters["login/isLoggedIn"] && routename == "/") {
    return false
  }
  return store.getters["login/isLoggedIn"]
})

const logout = () => {
  store.dispatch("login/logoutUser").then(() => {
    router.push("/login")
  })
}
</script>

<style>
  @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap");

  #app {
    font-family: "Poppins", Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }
</style>